import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { NOTIFICATION_SERVICE } from '@eggplant/api-hosts'
import type { ReactElement } from 'react'
import type { TestManagementToolInputs } from '@eggplant/types'

interface Props {
  id: string
  children?: (response: TestManagementToolInputs) => ReactElement
  onSuccess?: (notificationSettings: TestManagementToolInputs) => void
}

const GetSingleTestManagementIntegrationRequest = ({
  id,
  children,
  onSuccess
}: Props) => {
  const url = `${NOTIFICATION_SERVICE}/integrations/${id}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default GetSingleTestManagementIntegrationRequest
